import React, { useContext } from 'react';
import { Menu, Spin } from 'antd';

import './index.less';

import { useNavigate } from 'react-router-dom';
import { useModalState } from 'hooks/useModalState';
import MyProfileModal from './MyProfile/MyProfileModal';
import ISettings from 'icons/ISettings';

import IUser from 'icons/IUser';
import { EditOutlined, LoadingOutlined } from '@ant-design/icons';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import { AuthContext } from 'components/Auth/Auth';
import HeaderDropdown from 'components/HeaderDropdown';

const AvatarDropdown = (props: any) => {
  const myProfileModal = useModalState();


  const { isInspect, setInspectMode } = useContext(AuthContext);

  const menuHeaderDropdown = (
    <AuthContext.Consumer>
      {(context) => (
        <>
          <Menu className={'menu'} selectedKeys={[]}>
            {!props.isExcludedFromLayout && (
              <Menu.Item key="settings" onClick={myProfileModal.open}>
                <ISettings />
                Account settings
              </Menu.Item>
            )}
            {(localStorage.getItem('userrole') === 'ADMIN' ||
              localStorage.getItem('userrole') === 'BROKER') && (
              <>
                <Menu.Divider />
                <Menu.Item
                  key="inspect"
                  onClick={() => {
                    setInspectMode(!isInspect);
                  }}
                >
                  {isInspect ? (
                    <LoadingOutlined style={{ fontSize: 21 }} />
                  ) : (
                    <EditOutlined style={{ fontSize: 21 }} />
                  )}
                  Inspect Mode
                </Menu.Item>
              </>
            )}

            {localStorage.getItem('userrole') === 'WHOLESALE' && (
              <>
                <Menu.Divider />

                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a
                      onClick={() => {
                        setVisible(true);
                      }}
                    >
                      <Menu.Item icon={<IUser />} key="profile">
                        My Profile
                      </Menu.Item>
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <ThirdPartyModal
                      tpId={Number(localStorage.getItem('tpid')) ?? 0}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title={localStorage.getItem('name') ?? ''}
                      iscreate={false}
                    />
                  )}
                />
              </>
            )}
           
          </Menu>
          
        </>
      )}
    </AuthContext.Consumer>
  );
  return localStorage.getItem('username') ? (
    <>
      <HeaderDropdown
        overlay={menuHeaderDropdown}
        overlayClassName="header-dropdown"
      >
        <span className={`action account`}>
          <IUser />
          <span className={'name'}>
            {localStorage.getItem('name')}
          </span>
        </span>
      </HeaderDropdown>
      <MyProfileModal
        visible={myProfileModal.visible}
        onCancel={myProfileModal.close}
      />
    </>
    
  ) : (
    <Spin
      size="small"
      style={{
        marginLeft: 8,
        marginRight: 8,
      }}
    />
  );
};

export default AvatarDropdown;
